import { DefaultAutocompleteDefinitions } from "widgets/WidgetUtils";

export const autocompleteConfig = {
  "!doc":
    "The Button group widget represents a set of buttons in a group. Group can have simple buttons or menu buttons with drop-down items.",
  "!url": "https://docs.appsmith.com/widget-reference/button-group",
  isVisible: DefaultAutocompleteDefinitions.isVisible,
};
